import React, { Component } from "react";
import { Table, THead, TH, TD, TBody, TR } from "@react/react-spectrum/Table";
import Button from "@react/react-spectrum/Button";
import Dialog from "@react/react-spectrum/Dialog";
import Wait from "@react/react-spectrum/Wait";
import { Provider } from "react-redux";
import { Translate } from "react-redux-i18n";
import store from "../../store";
import { GridColumn, GridRow } from "@react/react-spectrum/Grid";
import Select from "@react/react-spectrum/Select";
import throwError, { toastPartnerApiFailure } from "../../comps/errorToast";

class ReassignContactDisplay extends Component {
  constructor(props) {
    super(props);
    this.state = {
      popupValidation: {},
      popupMode: null,
      isSaving: false,
      isLoading: true,
      reassignContacts: [],
      primaryContactIndex: -1,
      secondaryContactIndex: -1,
    };
  }

  onFetchComplete = (responseData) => {
    let primaryContactIndex = -1;
    let secondaryContactIndex = -1;
    responseData.contacts.map((item, index) => {
      if (item.mainContactType === "Primary") {
        primaryContactIndex = index;
      } else if (item.mainContactType === "Secondary")
        secondaryContactIndex = index;
      return null;
    });
    this.setState({
      isLoading: false,
      reassignContacts: responseData.contacts,
      primaryContactIndex: primaryContactIndex,
      secondaryContactIndex: secondaryContactIndex,
    });
  };

  OnReassignContactButtonClick() {
    this.setState({ popupMode: "reassignContact", isLoading: true });
    this.props.connector.fetchReassignContacts(
      this.onFetchComplete,
      this.props.partnerData.partnerInfo.accountId,
    );
  }

  validate = () => {
    return true;
    /*if(this.state.primaryContactIndex ===-1 || this.state.secondaryContactIndex ===-1)
       return false;
       else return true;*/
  };

  popupSave = () => {
    let contacts = this.state.reassignContacts.map((obj) => {
      return { contactId: obj.contactId, mainContactType: obj.mainContactType };
    });
    this.props.isSavingToggle(true);
    this.props.connector.updateReassignContacts(
      this.onSaveComplete,
      { contacts: contacts },
      this.props.formStates["accountId"],
    );
  };
  onSaveComplete = (response) => {
    if (response?.isError) {
      if (response?.messageCode)
        throwError(
          <Translate value={"managePartnership." + response?.messageCode} />,
        );
      else toastPartnerApiFailure(response);
    } else {
      window.location.reload();
      //this.setState({ popupMode: null , reassignContacts : [], primaryContactIndex:0, secondaryContactIndex:0 });
    }
    this.props.isSavingToggle(false);
  };

  onContactTypeChange(e, index) {
    let temporaryContacts = this.state.reassignContacts;
    temporaryContacts[index].mainContactType = e;
    if (e === "Primary") {
      if (this.state.primaryContactIndex !== -1)
        temporaryContacts[this.state.primaryContactIndex].mainContactType =
          "Other";
      this.setState({
        reassignContacts: temporaryContacts,
        primaryContactIndex: index,
        secondaryContactIndex:
          index === this.state.secondaryContactIndex
            ? -1
            : this.state.secondaryContactIndex,
      });
    } else if (e === "Secondary") {
      if (this.state.secondaryContactIndex !== -1)
        temporaryContacts[this.state.secondaryContactIndex].mainContactType =
          "Other";
      this.setState({
        reassignContacts: temporaryContacts,
        secondaryContactIndex: index,
        primaryContactIndex:
          index === this.state.primaryContactIndex
            ? -1
            : this.state.primaryContactIndex,
      });
    } else {
      this.setState({
        reassignContacts: temporaryContacts,
        primaryContactIndex:
          index === this.state.primaryContactIndex
            ? -1
            : this.state.primaryContactIndex,
        secondaryContactIndex:
          index === this.state.secondaryContactIndex
            ? -1
            : this.state.secondaryContactIndex,
      });
    }
  }

  render() {
    const tableBody = [];
    {
      this.state.reassignContacts.map((item, index) => {
        let options = [
          { label: "Primary", value: "Primary" },
          { label: "Secondary", value: "Secondary" },
          { label: "Other", value: "Other" },
        ];
        tableBody.push(
          <TR key={item.email}>
            <TD divider>
              <Select
                quiet
                closeOnSelect
                value={item.mainContactType}
                onChange={(e) => {
                  this.onContactTypeChange(e, index);
                }}
                options={options}
              ></Select>
            </TD>
            <TD divider>{item.firstName + " " + item.lastName}</TD>
            <TD divider>{item.email}</TD>
          </TR>,
        );
      });
    }

    return (
      <div>
        {this.state.popupMode ? (
          <div className="overlay" style={{ zIndex: "2" }}></div>
        ) : null}

        <Button
          className="button-action margin-action"
          variant="primary"
          disabled={Boolean(this.props.isRestrictedSanctionCountry)}
          onClick={() => {
            this.OnReassignContactButtonClick();
          }}
        >
          <Translate value="managePartnership.ConsolePartnerReassignBtnLabel" />
        </Button>
        {this.state.popupMode === "reassignContact" ? (
          <Dialog
            confirmDisabled={!this.validate()}
            className="customDialog"
            variant="confirmation"
            title={
              <Translate value="managePartnership.ReAssignSectionHeader" />
            }
            confirmLabel={<Translate value="managePartnership.TrngSaveClose" />}
            onConfirm={() => {
              this.popupSave();
            }}
            onCancel={() => {
              this.setState({
                popupMode: null,
                reassignContacts: [],
                primaryContactIndex: 0,
                secondaryContactIndex: 0,
              });
            }}
            cancelLabel={<Translate value="managePartnership.TrngClose" />}
          >
            <Provider store={store}>
              <GridRow>
                <GridColumn size={[12, 12, 12, 12]}>
                  {!this.validate() && !this.state.isLoading ? (
                    <p style={{ color: "red" }}>
                      One Primary and one Secondary contact required
                    </p>
                  ) : null}
                  {/* <p>1.To reassign the Primary Contact:<br />
                                                            Change the "Contact Type" for your contacts </p>
                                <p>If a contact is not listed, then he/she has not accepted the invitation to join account.</p> */}
                  <Translate value="managePartnership.ReAssignInstructionLabel" />
                  {this.state.isLoading ? (
                    <div className="reassignWell">
                      <Wait size="L" />
                    </div>
                  ) : (
                    <Table id="table">
                      <THead>
                        <TH>
                          <Translate value="managePartnership.ReAssignMainContactTypeLabel" />
                        </TH>
                        <TH>
                          <Translate value="managePartnership.ReAssignContactNameLabel" />
                        </TH>
                        <TH>
                          <Translate value="managePartnership.ReAssignEmailAddLabel" />
                        </TH>
                      </THead>
                      <TBody>{tableBody}</TBody>
                    </Table>
                  )}
                </GridColumn>
              </GridRow>
            </Provider>
          </Dialog>
        ) : null}
      </div>
    );
  }
}

export default ReassignContactDisplay;
